
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getAppRules = {
  getAppRulesList(params) {
    return axios.post(
      `/api/admin/rule/list`,
      qs.stringify(params)
    );
  },
  postSaveAppRules(params) {
    return axios.post(
      `/api/admin/rule/save`,
      qs.stringify(params)
    );
  },
  getAppRulesInfo(params) {
    return axios.post(
      `/api/admin/rule/info`,
      qs.stringify(params)
    );
  },
  postAddAppRules(params) {
    return axios.post(
      `/api/admin/rule/add`,
      qs.stringify(params)
    );
  },
  postDelAppRules(params) {
    return axios.post(
      `/api/admin/rule/del`,
      qs.stringify(params)
    );
  },
};
export default getAppRules;
